import { Injectable } from "@angular/core"
import { LoggerService } from '@core/services/infra/logger.service';;

@Injectable({
    providedIn: 'root'
})
export class DatesService{
  private readonly CONTEXT = 'DatesService';

  constructor(private logger: LoggerService) {}


    /**
     * Function used to return a date in the proper format to set an Date Input
     */
    getDateInputFormat(dateToConvert: Date): string{
        return dateToConvert.toISOString().split("T")[0];
    }

    removeADay(dateToChange:Date): Date {
        //Il faut ajouter une heure pour compenser potentiellement l'heure d'été :-)
        return new Date(dateToChange.getTime() - ( 24 * 60 * 60 * 1000) + (60*60*1000)+1);
    }
    
    /**
     * Add X months to current date and return Date.
     *
     * KNOWN BUG (locked by spec): the `dateMonth == 2` clamp checks the
     * *source* month, but month indexes are 0-based — so 2 = March, not
     * February. Result: Jan 31 + 1 month → March 2 (native Date roll-over),
     * not Feb 28/29. The fix is to check the *target* month (`tmpMonth`),
     * but doing so changes contract end-date computations across the app —
     * needs a coordinated review before flipping. Until then, callers that
     * care about end-of-month semantics should clamp themselves.
     */
    addXMonthsToDate(date: Date, xMonths: number): Date{
        this.logger.debug("Using add x months service", this.CONTEXT);
        const dateYear:number = date.getFullYear();
        const dateMonth:number = date.getMonth();
        const dateDay:number = date.getDate();

        let tmpYear: number;
        let tmpMonth: number;
        let tmpDate: number;
        
        tmpYear = dateYear + Math.floor(xMonths / 12);

        tmpMonth = dateMonth + ( xMonths % 12 );
        if(tmpMonth > 12){
            tmpYear++;
            tmpMonth -= 12;
        }

        if(dateDay < 28){
            tmpDate = dateDay;
        }else{
            if(dateMonth == 2){
                tmpDate = 28;
            }else{
                if(dateMonth <31){
                    tmpDate = dateDay;
                }else{
                    if(tmpMonth == 4 || tmpMonth == 6 || tmpMonth == 9 || tmpMonth == 11) {
                        tmpDate = 30;
                    }else{
                        tmpDate = 31;
                    }
                }
 
            }
        }
        this.logger.debug("Date calculated : " + new Date(tmpYear, tmpMonth, tmpDate), this.CONTEXT);
        const tmpReturn: Date = new Date(tmpYear, tmpMonth, tmpDate);
        return tmpReturn;
    }

    getMonthsBetween(date1: Date,date2: Date,roundUpFractionalMonths: boolean): number
    {
        let startDate: Date = date1;
        let endDate: Date = date2;
        let inverse = false;
        if(date1 > date2)
        {
            startDate = date2;
            endDate = date1;
            inverse = true;
        }
    
        //Calculate the differences between the start and end dates
        const yearsDifference = endDate.getFullYear()-startDate.getFullYear();
        const monthsDifference = endDate.getMonth()-startDate.getMonth();
        const daysDifference = endDate.getDate()-startDate.getDate();
    
        let monthCorrection=0;
        //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
        //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
        if(roundUpFractionalMonths===true && daysDifference>0)
        {
            monthCorrection=1;
        }
        //If the day difference between the 2 months is negative, the last month is not a whole month.
        else if(roundUpFractionalMonths !== true && daysDifference < 0)
        {
            monthCorrection=-1;
        }
    
        return (inverse ? -1 : 1) * (yearsDifference * 12 + monthsDifference + monthCorrection);
    };  

    isDateBetween(date:Date, startDate:Date, endDate:Date):boolean{
        if(date.getTime() >= new Date(startDate).getTime() && date.getTime() <= new Date(endDate).getTime()){
            return true;
        }else{
            return false;
        }
    }

    isDateInTheFuture(date:Date):boolean{
        if(date.getTime() > new Date(Date.now()).getTime()){
            return true;
        }
        return false;
    }

}